// src/components/TopNav/PreviewToggleButton.jsx
import { useLocation, useNavigate, matchPath } from 'react-router-dom'
import { EyeIcon, PencilIcon } from '@heroicons/react/24/outline'
import Tooltip from '../FloatingWidgets/TooltipSystem'
import clsx from 'clsx'

export default function PreviewToggleButton() {
  const location = useLocation()
  const navigate = useNavigate()

  // Matches either the preview or edit routes
  const previewMatch = matchPath('/recipes/:id/print', location.pathname)
  const editMatch = matchPath('/recipes/:id/edit', location.pathname)

  const recipeId = previewMatch?.params?.id || editMatch?.params?.id
  const isPreview = !!previewMatch

  if (!recipeId) return null

  const handleToggle = () => {
    if (isPreview) {
      navigate(`/recipes/${recipeId}/edit`)
    } else {
      navigate(`/recipes/${recipeId}/print`)
    }
  }

  return (
    <Tooltip text={isPreview ? 'Switch to edit mode' : 'Preview recipe card'}>
      <button
        onClick={handleToggle}
        className={clsx(
          'ml-2 p-2 rounded focus:outline-none',
          'hover:bg-soft-yellow/40 focus-visible:ring-2 focus-visible:ring-amber-400'
        )}
        aria-label={isPreview ? 'Switch to editor' : 'Switch to preview'}
      >
        {isPreview ? (
          <PencilIcon className="h-6 w-6 text-charcoal" />
        ) : (
          <EyeIcon className="h-6 w-6 text-charcoal" />
        )}
      </button>
    </Tooltip>
  )
}